module.exports = __webpack_public_path__ + "static/media/gradientBackgroundSilverCard.2d5ad509.png";